import { Activity, Clock, FileCheck2, Hospital, Users2 } from 'lucide-react';
import Container from '../../common/Container';
import ScrollReveal from '../common/ScrollReveal';

const stats = [
  {
    icon: Hospital,
    value: '10+',
    label: 'Core Hospital Modules',
    detail: 'From OPD to ATD & Discharge',
  },
  {
    icon: Clock,
    value: '< 60s',
    label: 'Patient Intake & Invoicing',
    detail: 'Fast walk-in billing & tokens',
  },
  {
    icon: FileCheck2,
    value: '100%',
    label: 'Paperless Documentation',
    detail: 'Standardized digital summaries',
  },
  {
    icon: Activity,
    value: '24 / 7',
    label: 'Live Bed & Census Visibility',
    detail: 'Real-time vacant & reserved tracking',
  },
  {
    icon: Users2,
    value: 'Multi-Role',
    label: 'Staff & Doctor Portals',
    detail: 'Role-based security access',
  },
];

export const Stats = () => {
  return (
    <section className="py-12 bg-slate-50 border-y border-slate-200/80 relative">
      <Container>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 lg:gap-8">
          {stats.map((item, idx) => {
            const Icon = item.icon;
            return (
              <ScrollReveal
                key={idx}
                direction="up"
                delay={idx * 100}
                className="flex flex-col items-center text-center p-4 rounded-2xl bg-white/70 hover:bg-white border border-slate-200/60 hover:border-[#0D7893]/40 hover:shadow-lg hover:shadow-[#0D7893]/5 transition-all duration-300"
              >
                <div className="p-3 rounded-xl bg-[#0D7893]/10 text-[#0D7893] mb-3">
                  <Icon className="w-6 h-6" />
                </div>
                <div className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
                  {item.value}
                </div>
                <div className="text-sm font-semibold text-slate-800 mt-1">
                  {item.label}
                </div>
                <div className="text-xs text-slate-500 mt-0.5">
                  {item.detail}
                </div>
              </ScrollReveal>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default Stats;
